import api from '../utils/api';
import qs from '../utils/qs';

export const getUsers = async (data) => {
    try {
        const response = await api.post(`/user/search`, data);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message };
    }
}

export const getUserById = async (id) => {
    try {
        const response = await api.get(`/user/${id}`);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message };
    }
}

export const addUsers = async (data) => {
    try {
        const response = await api.post(`/user/create`, data);
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        return { error: error.response.data.message };
    }
}

export const editUsers = async (params, data) => {
    try {
        const response = await api.put(`/user/${params}`, data);
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        return { error: error.response.data.message };
    }
}

export const changePassword = async (params, data) => {
    try {
        const response = await api.put(`/user/change-password/${params}`, data);
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        return { error: error.response.data.message };
    }
}
export const deleteUser = async (params) => {
    try {
        const response = await api.put(`/user/status/${params}`, { status: 2 });
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        return { error: error.response.data.message };
    }
}

export const userStatusChange = async (params,data) => {
    try {
        const response = await api.put(`/user/status/${params}`, data);
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        return { error: error.response.data.message };
    }
}